module.exports = __webpack_public_path__ + "img/amazon_btn.7ab5bc1f.png";